module.exports = __webpack_public_path__ + "img/华夏银行.6b02312e.png";